import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, VStack, Heading, Flex, Container } from "@chakra-ui/react";
import { PRODUCT_MAPPING } from "~/DiagnosticsApp/constants";
import { useCurrentDiagnosticUser } from "~/hooks/useCurrentDiagnosticUser";
import { ProductCheckoutCard } from "./ProductCheckoutCard";

export const OrderTests: FC = () => {
  const { t } = useTranslation();
  const currentDiagnosticUser = useCurrentDiagnosticUser();
  const gender = currentDiagnosticUser?.patientProfileGender;

  return (
    <Box bg="white" w="100%" py={12}>
      <Container maxW="container.xl">
        <VStack spacing={12} align="stretch">
          {/* <Heading as="h2" size="xl" textAlign="center"> */}
          {/* </Heading> */}
          <Heading
            as="h2" size="xl" textAlign="center"
          >
            {t("diagnosticDashboard.orderTests.title")}
          </Heading>

          {gender === "male" ? (
            <VStack spacing={8} align="stretch">
              <Flex
                gap={6}
                wrap="wrap"
                justify="center"
              >
                <ProductCheckoutCard
                  product={PRODUCT_MAPPING.mens_basics}
                  tagline={t("diagnosticDashboard.orderTests.sections.men.products.mens_basics.tagline")}
                  description={t("diagnosticDashboard.orderTests.sections.men.products.mens_basics.description")}
                  buttonText={t("diagnosticDashboard.orderTests.buttonText")}
                />
                {/* <ProductCheckoutCard */}
                {/*   product={PRODUCT_MAPPING.mens_advanced} */}
                {/*   tagline={t("diagnosticDashboard.orderTests.sections.men.products.mens_advanced.tagline")} */}
                {/*   description={t("diagnosticDashboard.orderTests.sections.men.products.mens_advanced.description")} */}
                {/*   buttonText={t("diagnosticDashboard.orderTests.buttonText")} */}
                {/* /> */}
              </Flex>
            </VStack>
          ) : (
            <>
              <VStack spacing={8} align="stretch">
                <Flex
                  gap={6}
                  wrap="wrap"
                  justify="center"
                >
                  <ProductCheckoutCard
                    product={PRODUCT_MAPPING.womens_basics}
                    tagline={t("diagnosticDashboard.orderTests.sections.women.products.womens_basics.tagline")}
                    description={t("diagnosticDashboard.orderTests.sections.women.products.womens_basics.description")}
                    buttonText={t("diagnosticDashboard.orderTests.buttonText")}
                  />
                  <ProductCheckoutCard
                    product={PRODUCT_MAPPING.womens_advanced}
                    tagline={t("diagnosticDashboard.orderTests.sections.women.products.womens_advanced.tagline")}
                    description={t("diagnosticDashboard.orderTests.sections.women.products.womens_advanced.description")}
                    buttonText={t("diagnosticDashboard.orderTests.buttonText")}
                  />
                </Flex>
              </VStack>

              <VStack spacing={8} align="stretch">
                <Flex
                  gap={6}
                  wrap="wrap"
                  justify="center"
                >
                  <ProductCheckoutCard
                    product={PRODUCT_MAPPING.ovulation_support}
                    tagline={t("diagnosticDashboard.orderTests.sections.support.products.ovulation_support.tagline")}
                    description={t("diagnosticDashboard.orderTests.sections.support.products.ovulation_support.description")}
                    buttonText={t("diagnosticDashboard.orderTests.buttonText")}
                  />
                  <ProductCheckoutCard
                    product={PRODUCT_MAPPING.pregnancy_support}
                    tagline={t("diagnosticDashboard.orderTests.sections.support.products.pregnancy_support.tagline")}
                    description={t("diagnosticDashboard.orderTests.sections.support.products.pregnancy_support.description")}
                    buttonText={t("diagnosticDashboard.orderTests.buttonText")}
                  />
                </Flex>
              </VStack>
            </>
          )}
        </VStack>
      </Container>
    </Box>
  );
};
